import request from "_private/utils/request";

/**
 * 获取菜单权限列表
 * @param {*} data
 * {roleId: ""}
 */
export function FetchFindAllMenuTree(data) {
    return request({
        url: "/base/role/findAllMenuTree",
        method: "post",
        data
    });
}

/**
 * 新增、修改、查询角色扩展字段
 * @param {*} data
 * { edit: "", primaryKeyId: "" }
 */
export function FetchGetExtColumn(data) {
    return request({
        url: "/base/role/getExtColumn",
        method: "post",
        data
    });
}

/**
 * 查询角色列表
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/role/findByPage",
        method: "post",
        data
    });
}

/**
 * 新增、修改角色
 * @param {*} data
 */
export function FetchSaveRole(data) {
    return request({
        url: "/base/role/saveRole",
        method: "post",
        data
    });
}

/**
 * 删除用户
 * @param {*} data
 */
export function FetchDeleteUser(data) {
    return request({
        url: "/base/role/deleteRole",
        method: "post",
        data
    });
}

/**
 * 修改角色信息时先获取角色信息
 * @param {*} data
 */
export function FetchFindRoleDetailByRoleId(data) {
    return request({
        url: "/base/role/findRoleDetailByRoleId",
        method: "post",
        data
    });
}

/**
 * 校验角色名称
 * @param {*} data
 */
export function FetchfindExistRoleName(data) {
    return request({
        url: "/base/role/checkRoleNameIsExist",
        method: "post",
        data
    });
}

